
$(function () {

    function setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let subtotalPrice = 0;
    let discountPercentage;
    let discountAmount;
    // let hrefShareCode = '';
    let hrefShareCode = 'mailto:?Subject=Wishlist&body=Please see wishlist items below; %0D%0A ';
    let emailBody = 'Please see your wishlist items below. ';
    let emailTo = '';

    zeewishInit();

    $(window).on('loadstatechanged', function (e) {
        zeewishInit();
    });


    function zeewishInit() {

        if($('body').hasClass('body-template-shared-wishlist')) {
            const queryString = window.location.search;
            console.log(queryString);           
            const urlParams = new URLSearchParams(queryString);
            let params = urlParams.get('i');
            paramsArr = params.split(" ");
            console.log(params);
            console.log(paramsArr);
             paramsArr.forEach(function(item) {
              console.log(item);
              loadProductIDWishlist(item);
            });

            if (paramsArr.length == 0) {
                $('.zeeWishCount').hide();
                $('.has-items-container').hide();
                $('.no-item-text').show();
                $('.your-selection-container').hide();
                $('.zeeWishlist-subtotal').hide();
    
            } else {
                $('.zeeWishlist-subtotal').show();
                $('.has-items-container').show();
                $('.no-item-text').hide();
                $('.your-selection-container').show();
                //$('.zeeWishCount').show();
                //$('.zeeWishCount').text(paramsArr.length);
                //$('.zeeWishCount').css('background-color:red;');
            }          
          
            
        }
        else {
            let userWishlist = getCookie("zeewish");
            if (userWishlist != "") {
                let userWishArr = JSON.parse(userWishlist);

                for (var i = 0; i < userWishArr.length; i++) {
                    loadProductWishlist(userWishArr[i]);
                    $('.like').each(function () {    
                        let cookieValues = userWishArr[i].split(",");
                        let productHandle = cookieValues[0];                  
    
                        if ($(this).data("like") == productHandle) {
                            $(this).addClass('is-liked');
                        }
                    });
                }
    
                if (userWishArr.length == 0) {
                    $('.zeeWishCount').hide();
                    $('.has-items-container').hide();
                    $('.no-item-text').show();
                    $('.your-selection-container').hide();
                    $('.zeeWishlist-subtotal').hide();
    
                } else {
                    $('.zeeWishlist-subtotal').show();
                    $('.has-items-container').show();
                    $('.no-item-text').hide();
                    $('.your-selection-container').show();
                    $('.zeeWishCount').show();
                    $('.zeeWishCount').text(userWishArr.length);
                    $('.zeeWishCount').css('background-color:red;');
    
                    
                    setTimeout(function(){
                        console.log('SET TIMEOUT CALLED')
                        hrefShareCode += '%0D%0A Subtotal NET - '+Shopify.formatMoney((subtotalPrice/1.2) , '£{{amount}}');
                        hrefShareCode += '%0D%0A Subtotal VAT - '+Shopify.formatMoney(subtotalPrice - (subtotalPrice/1.2) , '£{{amount}}');
                        hrefShareCode += '%0D%0A Subtotal RETAIL - '+Shopify.formatMoney((subtotalPrice) , '£{{amount}}');
                        //$('.js-wishlist-email-share').attr("href", hrefShareCode);   
                    }, 500);               
                }            
    
            } else {
            }

        }
    }

    function addToCookie(value) {
        let userWish = getCookie("zeewish");
        if (userWish != "") {
            let userWishArr = JSON.parse(userWish);

            if (userWishArr.indexOf(value) > -1) {

            } else {
                userWishArr.push(value);
                setCookie("zeewish", JSON.stringify(userWishArr), 90);
            }

            if (userWishArr.length == 0) {
                $('.zeeWishCount').hide();
                $('.no-item-text').show();
                $('.your-selection-container').hide();
                $('.zeeWishlist-subtotal').hide();

            } else {
                $('.zeeWishlist-subtotal').show();
                $('.your-selection-container').show();
                $('.no-item-text').hide();
                $('.zeeWishCount').show();
                $('.zeeWishCount').text(userWishArr.length);
                $('.zeeWishCount').css('background-color:red;');
            }

        } else {
            let userWishArr = [value];
            setCookie("zeewish", JSON.stringify(userWishArr), 90);

            if (userWishArr.length == 0) {
                $('.zeeWishlist-subtotal').hide();
                $('.zeeWishCount').hide();
                $('.no-item-text').show();
                $('.your-selection-container').hide();
            } else {
                $('.zeeWishlist-subtotal').show();
                $('.no-item-text').hide();
                $('.your-selection-container').show();
                $('.zeeWishCount').show();
                $('.zeeWishCount').text(userWishArr.length);
                $('.zeeWishCount').css('background-color:red;');
            }
        }
    }

    function removeFromCookie(value) {
        let userWish = getCookie("zeewish");
        if (userWish != "") {

            let userWishArr = JSON.parse(userWish);

            if (userWishArr.indexOf(value) > -1) {
                let index = userWishArr.indexOf(value);
                if (index > -1) {
                    userWishArr.splice(index, 1);
                }
            }
            setCookie("zeewish", JSON.stringify(userWishArr), 90);

            if (userWishArr.length == 0) {
                $('.zeeWishCount').hide();
                $('.no-item-text').show();
                $('.your-selection-container').hide();
                $('.zeeWishlist-subtotal').hide();

            } else {
                $('.zeeWishlist-subtotal').show();
                $('.no-item-text').hide();
                $('.your-selection-container').show();
                $('.zeeWishCount').show();
                $('.zeeWishCount').text(userWishArr.length);
                $('.zeeWishCount').css('background-color:red;');
            }

        } else {


        }
    }

    async function getProductById(id) {
      try {
    	const handle = (await fetch(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`)
    		.then(response => response.json())
    		.then(response => response.resources.results.products.shift())).handle;
    
    	return await fetch(`/products/${handle}.js`).then(response => response.json());
      } catch(e){
        
      }
    }
  
    async function loadProductIDWishlist(id) {
      console.log('load id wishlist product '+id);
      let product;
      try {
        product = await getProductById(id);
      } catch(e){
        console.log('ERROR GET PRODUCT ID');
      }
      console.log(product);
      let productID = id;
      let loadcssSelector = ".zeeWishlist-table [data-liked='" + product.handle + "']";
        if (!$(loadcssSelector).length && product != null) {
            // let apiURL = "/products/" + productHandle + ".js";
            // await jQuery.getJSON(apiURL, function (product) {
                let wheelSize = 0;
                for (let i = 0; i < product.tags.length; i++) {
                    for (x = 16; x <= 24; x++) {
                        let xStr = x + '"';
                        if (product.tags[i] == xStr) {
                            wheelSize = xStr;
                            break;
                        }
                    }
                } 
                console.log('load products');
              
                let productHTML = '';
                let productPriceHTML = '';
              
                let productOptions = '';
                if(product.type == 'clothing' || product.type == 'Clothing' ){
                  productOptions = '<select name="id" id="product-select">';
                } else {
                  productOptions = '<select name="id" id="product-select" class="product-form__variants hide hidden">';
                }
                product.variants.forEach(function(item, index) {
                      if(index == 0){
                        productOptions += '<option data-sku="'+item.sku+'" data-index="'+index+'" value="'+item.id+'" selected="selected">'+item.title+'</option>';
                      } else {
                         productOptions += '<option data-sku="'+item.sku+'" data-index="'+index+'" value="'+item.id+'" >'+item.title+'</option>';
                      }                                      
                  });                
                  productOptions += '</select>'
                 
                
              
                if (product.type == "Wheel" || product.type == "wheel" || product.type == "wheels" || product.type == "Wheels" || product.type == "Wheels Double") {
                    productHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * 4 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + product.title + '</p><p class="zeeWishlist-size">' + wheelSize + '</p></a></div>';

                    if (product.available) {
                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * 4 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + product.title + '</p><p class="zeeWishlist-size">' + wheelSize + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2 * 4, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a> <form class="add-to-cart-form cart" method="post" action="/cart/add" enctype="multipart/form-data" id="cart-form" data-product_id="'+product.id+'">'+productOptions+'<input type="hidden" id="quantity" name="quantity" value="4"><button type="submit" id="shopify_add_to_cart" class="product-quantity-input add_to_cart_button ajax_form_cart asingle_add_to_cart_button button alt btn">Move To Cart</button></form></div>';
                    } else {
                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * 4 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + product.title + '</p><p class="zeeWishlist-size">' + wheelSize + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2 * 4, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a></div>';
                    }
                    subtotalPrice += product.price * 1.2 * 4;
                } else {
                    productHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><p class="zeeWishlist-title">' + product.title + '</p></a></div>';
                     
                        if (product.available) {
                            if(product.price != 0){
                              productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                              Shopify.formatMoney(product.price * 1.2, $('.zeewishlist-page').data('moneyformat'))
                              + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a><form class="add-to-cart-form cart" method="post" action="/cart/add" enctype="multipart/form-data" id="cart-form" data-product_id="'+product.id+'">'+productOptions+'<input type="hidden" id="quantity" name="quantity" value="1"><button type="submit" id="shopify_add_to_cart" class="product-quantity-input add_to_cart_button ajax_form_cart asingle_add_to_cart_button button alt btn">Move To Cart</button></form></div>';
                            } else {
                               productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p></div>';
                            }
                          } else {
                            if(product.price != 0){
                            productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                                Shopify.formatMoney(product.price * 1.2, $('.zeewishlist-page').data('moneyformat'))
                                + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a></div>';
                            }
                            else {
                               productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p></div>';
                            }
                          }
                    
                    subtotalPrice += product.price * 1.2;
                }

                $('.wishlist-widget-side .zeeWishlist-table').append(productHTML);
                $('.wishlist-widget-side .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));
                $('.wishlist-widget-side #sideWishlistNet').text(Shopify.formatMoney(subtotalPrice/1.2, '£{{amount}}'));
                $('.wishlist-widget-side #sideWishlistVAT').text(Shopify.formatMoney(subtotalPrice - (subtotalPrice/1.2), '£{{amount}}'));
                $('.wishlist-widget-side #sideWishlistRetail').text(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));

                if ($('.zeewishlist-page').length) {
                    $('.zeewishlist-page .zeeWishlist-table').append(productPriceHTML);
                    if (product.type == "Wheel" || product.type == "wheel" || product.type == "wheels" || product.type == "Wheels" || product.type == "Wheels Double") {
                        hrefShareCode += '%0D%0A - ' + product.title + ' | Price '+Shopify.formatMoney(product.price * 1.2 * 4, '£{{amount}}') + ' %0D%0A https://projectkahn.com' + product.url +' %0D%0A ';
                    } else{
                        hrefShareCode += '%0D%0A -' + product.title +' | Price '+Shopify.formatMoney(product.price * 1.2, '£{{amount}}')+ ' %0D%0A https://projectkahn.com' + product.url + ' %0D%0A ';
                    }                
                  
                }                
                wishlistPageSubtotal();
            // });
        }
    }
  

    async function loadProductWishlist(cookieValue) {

        let cookieValues = cookieValue.split(",");
        let productHandle = cookieValues[0];
        let productID = cookieValues[1];

        let loadcssSelector = ".zeeWishlist-table [data-liked='" + productHandle + "']";
        if (!$(loadcssSelector).length) {
            let apiURL = "/products/" + productHandle + ".js";
            await jQuery.getJSON(apiURL, function (product) {
                let wheelSize = 0;
                for (let i = 0; i < product.tags.length; i++) {
                    for (x = 16; x <= 24; x++) {
                        let xStr = x + '"';
                        if (product.tags[i] == xStr) {
                            wheelSize = xStr;
                            break;
                        }
                    }
                } 

                console.log('load products');
              
                let productHTML = '';
                let productPriceHTML = '';
              
                let productOptions = '';
                if(product.type == 'clothing' || product.type == 'Clothing' ){
                  productOptions = '<select name="id" id="product-select">';
                } else {
                  productOptions = '<select name="id" id="product-select" class="product-form__variants hide hidden">';
                }
                product.variants.forEach(function(item, index) {
                      if(index == 0){
                        productOptions += '<option data-sku="'+item.sku+'" data-index="'+index+'" value="'+item.id+'" selected="selected">'+item.title+'</option>';
                      } else {
                         productOptions += '<option data-sku="'+item.sku+'" data-index="'+index+'" value="'+item.id+'" >'+item.title+'</option>';
                      }                                      
                  });                
                  productOptions += '</select>'
                 
                
              
                if (product.type == "Wheel" || product.type == "wheel" || product.type == "wheels" || product.type == "Wheels" || product.type == "Wheels Double") {
                    productHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * 4 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + product.title + '</p><p class="zeeWishlist-size">' + wheelSize + '</p></a></div>';

                    if (product.available) {
                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * 4 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + product.title + '</p><p class="zeeWishlist-size">' + wheelSize + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2 * 4, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a> <form class="add-to-cart-form cart" method="post" action="/cart/add" enctype="multipart/form-data" id="cart-form" data-product_id="'+product.id+'">'+productOptions+'<input type="hidden" id="quantity" name="quantity" value="4"><button type="submit" id="shopify_add_to_cart" class="product-quantity-input add_to_cart_button ajax_form_cart asingle_add_to_cart_button button alt btn">Move To Cart</button></form></div>';
                    } else {
                        productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 * 4 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><div class="" style="position:absolute;top:0;background-size:contain;width:100%;height:100%;background-image:url(https://cdn.shopify.com/s/files/1/0027/6588/1380/files/Shadow.png);"></div></div><p class="zeeWishlist-title">' + product.title + '</p><p class="zeeWishlist-size">' + wheelSize + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                            Shopify.formatMoney(product.price * 1.2 * 4, $('.zeewishlist-page').data('moneyformat'))
                            + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a></div>';
                    }
                    subtotalPrice += product.price * 1.2 * 4;
                } else {
                    productHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /><p class="zeeWishlist-title">' + product.title + '</p></a></div>';
                     
                        if (product.available) {
                            if(product.price != 0){
                              productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                              Shopify.formatMoney(product.price * 1.2, $('.zeewishlist-page').data('moneyformat'))
                              + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a><form class="add-to-cart-form cart" method="post" action="/cart/add" enctype="multipart/form-data" id="cart-form" data-product_id="'+product.id+'">'+productOptions+'<input type="hidden" id="quantity" name="quantity" value="1"><button type="submit" id="shopify_add_to_cart" class="product-quantity-input add_to_cart_button ajax_form_cart asingle_add_to_cart_button button alt btn">Move To Cart</button></form></div>';
                            } else {
                               productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p></div>';
                            }
                          } else {
                            if(product.price != 0){
                            productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p><p class="col-12 price text-center" style="padding-left:10px;font-weight:500;">' +
                                Shopify.formatMoney(product.price * 1.2, $('.zeewishlist-page').data('moneyformat'))
                                + '<small style="margin-left:3px;font-size: 8px;text-transform: uppercase;margin-bottom: 0px !important;letter-spacing: 1px;font-weight:600;" class="mb-4">INC. VAT</small></p></a></div>';
                            }
                            else {
                               productPriceHTML = '<div data-liked="' + product.handle + '" data-pid="' + productID + '" data-liked-price="' + product.price * 1.2 + '" class="zeeWishlist-item"><a class="zeeWishlist-cross">×</a><a href="' + product.url + '"><div style="position:relative;"><img class="zeeWishlist-img" src = "' + product.featured_image + '" /></div><p class="zeeWishlist-title">' + product.title + '</p></div>';
                            }
                          }
                    
                    subtotalPrice += product.price * 1.2;
                }

                $('.wishlist-widget-side .zeeWishlist-table').append(productHTML);
                $('.wishlist-widget-side .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));
                $('.wishlist-widget-side #sideWishlistNet').text(Shopify.formatMoney(subtotalPrice/1.2, '£{{amount}}'));
                $('.wishlist-widget-side #sideWishlistVAT').text(Shopify.formatMoney(subtotalPrice - (subtotalPrice/1.2), '£{{amount}}'));
                $('.wishlist-widget-side #sideWishlistRetail').text(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));

                if ($('.zeewishlist-page').length) {
                    $('.zeewishlist-page .zeeWishlist-table').append(productPriceHTML);
                    if (product.type == "Wheel" || product.type == "wheel" || product.type == "wheels" || product.type == "Wheels" || product.type == "Wheels Double") {
                        hrefShareCode += '%0D%0A - ' + product.title + ' | Price '+Shopify.formatMoney(product.price * 1.2 * 4, '£{{amount}}') + ' %0D%0A https://projectkahn.com' + product.url +' %0D%0A ';
                    } else{
                        hrefShareCode += '%0D%0A -' + product.title +' | Price '+Shopify.formatMoney(product.price * 1.2, '£{{amount}}')+ ' %0D%0A https://projectkahn.com' + product.url + ' %0D%0A ';
                    }                
                  
                }                
                wishlistPageSubtotal();

            });
        }
    }

    function removeFromProductWishlist(cookieValue) {

        let cookieValues = cookieValue.split(",");
        let productHandle = cookieValues[0];
        let productID = cookieValues[1];

        let itemcssSelector = "[data-like='" + productHandle + "']";
        if ($(itemcssSelector)) {
            $(itemcssSelector).removeClass('is-liked');

        }

        let removecssPriceSelector = ".wishlist-widget-side .zeeWishlist-table [data-liked='" + productHandle + "']";
        if ($(removecssPriceSelector).length) {
            subtotalPrice -= $(removecssPriceSelector).data('liked-price');
            $('.wishlist-widget-side .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));

            $('.wishlist-widget-side #sideWishlistNet').text(Shopify.formatMoney(subtotalPrice/1.2, '£{{amount}}'));
            $('.wishlist-widget-side #sideWishlistVAT').text(Shopify.formatMoney(subtotalPrice - (subtotalPrice/1.2), '£{{amount}}'));
            $('.wishlist-widget-side #sideWishlistRetail').text(Shopify.formatMoney(subtotalPrice, '£{{amount}}'));

        }

        let removecssSelector = ".zeeWishlist-table [data-liked='" + productHandle + "']";
        $(removecssSelector).fadeOut(300, function () {
            $(this).remove();
            removeFromCookie(cookieValue);
        });

        wishlistPageSubtotal();
    }

    function wishlistPageSubtotal(){
        if (!$('.zeewishlist-page-subtotal').length) {            

            let subtotalHTML = `
            <div class="zeewishlist-page-subtotal">                    
                <div class="zeeWishlist-subtotal" style="border-top: 1px solid grey;border-bottom: 1px solid grey;">

                <div style="max-width:430px;margin-left:auto;">
                    <div id="price-breakdown3" style="display: none;right:0px; position: absolute;background-color: #000;width: 300px;max-width: 100%;padding: 15px 30px 15px 15px; color: #FFF;margin-top: -75px;">
                        <a onclick="$('#price-breakdown3').hide()" style="color: #FFF;position: absolute;right: 5px;top: -2px;display: block;z-index: 99999; font-size: 28px; font-weight: 700; padding-right: 5px; cursor: pointer;">&times;</a>
                        <div class="row">
                        
                            <div class="col-4">
                                NET</br>
                                <span id="sideWishlistNet2"> ${ Shopify.formatMoney(subtotalPrice/1.2, '£{{amount}}') }</span>
                            </div> 
                            <div class="col-4">
                                UK VAT</br>
                                <span id="sideWishlistVAT2"> ${ Shopify.formatMoney(subtotalPrice - (subtotalPrice/1.2), '£{{amount}}') } </span>
                            </div>
                            <div class="col-4">
                                Retail</br>
                                <span id="sideWishlistRetail2"> ${ Shopify.formatMoney(subtotalPrice, '£{{amount}}') } </span>
                            </div>

                        </div>
                    </div> 
                    <h3 class="zeeWishlist-subtotal-text" style="border:none; padding:10px 0px;line-height: 1.7;">
                  
                    SUBTOTAL:
                        <span class="zeeWishlist-subtotal-price float-right price money" style="margin-top:5px;"> ${ Shopify.formatMoney(subtotalPrice, '£{{amount}}') } </span>
                        <span style="display: block;float: right;margin-right: 8px;margin-top: -2px;">
                            <img id="info-button" src="https://img.icons8.com/ios-filled/24/000000/info.png" onclick="$('#price-breakdown3').toggle(10); $('#wheels-breakdown').hide()" style="width: 20px;height: 20px;margin-left: 0px;"/>
                        </span>
                    </h3>
                </div>

            </div>
            
            </div>`;

            $('.zeewishlist-page').after( subtotalHTML );

        } else{

            $('.zeewishlist-page-subtotal .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice , '£{{amount}}'));

            $('.zeewishlist-page-subtotal #sideWishlistNet2').text(Shopify.formatMoney(subtotalPrice/1.2, '£{{amount}}'));
            $('.zeewishlist-page-subtotal #sideWishlistVAT2').text(Shopify.formatMoney(subtotalPrice - (subtotalPrice/1.2), '£{{amount}}'));
            $('.zeewishlist-page-subtotal #sideWishlistRetail2').text(Shopify.formatMoney((subtotalPrice), '£{{amount}}'));
        }

    }

    $('body').on('click', '.like', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-liked');
        let productHandle = $(this).data('like');
        let productVID = $(this).data('like-id');
        let cookieValue = productHandle + ',' + productVID;
        if ($(this).hasClass('is-liked')) {
            addToCookie(cookieValue);
            loadProductWishlist(cookieValue);

        } else {
            removeFromCookie(cookieValue);
            removeFromProductWishlist(cookieValue);
        }
    });

    $('.zeeWishlist-table').on('click', '.zeeWishlist-cross', function () {
        let removeValue = $(this).parent().data('liked') + ',' + $(this).parent().data('pid');
        removeFromProductWishlist(removeValue);
    });
    
    $('body').on('click', '.side-wishlist-heart', function () {
        $('.side-wishlist-heart input').show();
        $('.side-wishlist-heart').css('background-image' , 'none');
    }); 

    $('body').on('change', '.side-wishlist-heart #discount', function () {
        
        let percentage = (Number($(this).val()) / 100 ) ; 

        discountAmount = subtotalPrice * percentage;
    
        $('.wishlist-widget-side .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice - discountAmount, '£{{amount}}'));

        $('.wishlist-widget-side #sideWishlistNet').text(Shopify.formatMoney((subtotalPrice-discountAmount)/1.2, '£{{amount}}'));
        $('.wishlist-widget-side #sideWishlistVAT').text(Shopify.formatMoney(((subtotalPrice-discountAmount) - (subtotalPrice-discountAmount)/1.2), '£{{amount}}'));
        $('.wishlist-widget-side #sideWishlistRetail').text(Shopify.formatMoney((subtotalPrice - discountAmount), '£{{amount}}'));
            
    });

    $('body').on('change', '#discount2', function () {

        console.log( $(this).val() );

        let percentage = (Number($(this).val()) / 100 ) ; 
        console.log( percentage );

        discountAmount = subtotalPrice * percentage;
        discountPercentage = percentage;

         
        console.log( subtotalPrice ); 
        console.log( discountAmount );
    
        $('.zeewishlist-page-subtotal .zeeWishlist-subtotal-price').html(Shopify.formatMoney(subtotalPrice - discountAmount, '£{{amount}}'));

        $('.zeewishlist-page-subtotal .js-discount-amount').text('Discount Amount: -'+ Shopify.formatMoney(discountAmount, '£{{amount}}') );

        $('.zeewishlist-page-subtotal #sideWishlistNet2').text(Shopify.formatMoney((subtotalPrice-discountAmount)/1.2 , '£{{amount}}'));
        $('.zeewishlist-page-subtotal #sideWishlistVAT2').text(Shopify.formatMoney(((subtotalPrice-discountAmount) - (subtotalPrice-discountAmount)/1.2), '£{{amount}}'));
        $('.zeewishlist-page-subtotal #sideWishlistRetail2').text(Shopify.formatMoney((subtotalPrice - discountAmount), '£{{amount}}'));

    }); 


});
